export const common = {
  nav: {
    platform: 'Plattform',
    solutions: 'Lösungen',
    resources: 'Ressourcen',
    company: 'Unternehmen',
    requestDemo: 'Demo Anfordern',
    // Platform dropdown
    dashboard: 'Dashboard',
    analytics: 'Analytik',
    monitoring: 'Überwachung',
    compliance: 'Compliance',
    // Solutions dropdown
    iotDevices: 'IoT-Geräte',
    dataManagement: 'Datenverwaltung',
    aiAlerts: 'KI-Warnungen',
    cbamCompliance: 'CBAM-Compliance',
    // Resources dropdown
    documentation: 'Dokumentation',
    apiReference: 'API-Referenz',
    caseStudies: 'Fallstudien',
    blog: 'Blog',
    // Company dropdown
    about: 'Über Uns',
    careers: 'Karriere',
    contact: 'Kontakt',
    privacy: 'Datenschutz',
  },
  hero: {
    badge: 'Industrielles IoT-Platform',
    title1: 'Digitale Transformation',
    title2: 'Echtzeit-Überwachung',
    title3: 'Carbon Compliance',
    subtitle: 'Stärken Sie Ihre industriellen Abläufe mit KI-gesteuerten Erkenntnissen, Echtzeit-Datenverarbeitung und EU-CO2-Fußabdruck-Compliance-Lösungen',
    startTrial: 'Kostenlose Testversion Starten',
    watchDemo: 'Demo Ansehen',
    scrollExplore: 'Scrollen zum Erkunden',
    // Statistics
    stat1Value: '500+',
    stat1Label: 'Unternehmenskunden',
    stat2Value: '50.000+',
    stat2Label: 'Verbundene Geräte',
    stat3Value: '10M+',
    stat3Label: 'Datenpunkte / Tag',
    stat4Value: '99,9%',
    stat4Label: 'Betriebszeit-Garantie'
  },
  features: {
    sectionTitle: 'Kernlösungen',
    sectionSubtitle: 'Umfassende Plattform für industrielle digitale Transformation',
    feature1Title: 'Geräteüberwachung',
    feature1Desc: 'Echtzeit-Überwachung von Industrieanlagen mit fortschrittlichen Sensornetzwerken und IoT-Konnektivität',
    feature2Title: 'Datenlebenszyklus-Management',
    feature2Desc: 'Vollständiges Datenlebenszyklus-Management von der Erfassung bis zur Analyse und Archivierung',
    feature3Title: 'KI-Gestützte Warnungen',
    feature3Desc: 'Dualer Warnmodus: Definieren Sie eigene Schwellenwert- und Bedingungsregeln, oder lassen Sie die KI automatisch Anomalien und abnormale Muster erkennen — werden Sie benachrichtigt, bevor Probleme eskalieren.',
    feature4Title: 'CBAM Compliance',
    feature4Desc: 'EU Carbon Border Adjustment Mechanism Compliance-Lösungen mit automatisierter Berichterstattung',
    learnMore: 'Mehr Erfahren'
  },
  dashboard: {
    badge: 'Live Dashboard Vorschau',
    title: 'Überwachen Sie Alles in Echtzeit',
    subtitle: 'Anpassbare Dashboards mit Drag-and-Drop-Widgets, Echtzeit-Warnungen und umfassender Datenvisualisierung',
    metric1: '99,9%',
    metric1Label: 'Betriebszeit',
    metric2: '<50ms',
    metric2Label: 'Reaktionszeit',
    metric3: '10K+',
    metric3Label: 'Datenpunkte/Sek.',
    exploreDashboard: 'Dashboard Erkunden'
  },
  compliance: {
    sectionTitle: 'CBAM Compliance Leicht Gemacht',
    sectionSubtitle: 'Automatisierte CO2-Fußabdruck-Verfolgung und EU-Compliance-Dokumentation',
    card1Title: 'Automatisierte Berichterstattung',
    card1Desc: 'Erstellen Sie automatisch Compliance-Berichte mit Echtzeit-CO2-Emissionsdaten',
    card2Title: 'CO2-Fußabdruck-Verfolgung',
    card2Desc: 'Verfolgen und analysieren Sie CO2-Emissionen in Ihrer gesamten Produktionskette',
    card3Title: 'Compliance-Dokumentation',
    card3Desc: 'Vorgefertigte Vorlagen für EU CBAM Compliance-Dokumentation und Zertifizierung',
    downloadGuide: 'Compliance-Leitfaden Herunterladen',
    viewDetails: 'Mehr Erfahren'
  },
  cbam: {
    badge: 'EU CBAM Digitale Anforderungen',
    modalTitle: 'CBAM Digitalsystem Kernanforderungen',
    modalSubtitle: 'Von der Datenhierarchie zur vollständigen MRV-Digitalisierung — EU-Kohlenstoffgrenzkonformität',
    tab1: 'Datenhierarchie: Org → Produkt-/Linienebene',
    tab2: 'MRV Vollprozess-Digitalisierung',

    dataLayerIntroTitle: 'CBAM erfordert Emissionen auf Produktebene, nicht Unternehmensgesamtwerte',
    dataLayerIntroDesc: 'CBAM schreibt die Meldung eingebetteter Emissionen pro Tonne Produkt vor, einschließlich direkter + indirekter Emissionen, Zuteilung auf Produktionslinie/Prozessebene und tatsächliche Messwerte als Priorität gegenüber Schätzungen.',

    dataHierarchyTitle: 'Drei-Ebenen-Datenhierarchie',
    level1Label: 'Ebene 1 — Organisation',
    level1Title: 'Unternehmens- / Konzernebene',
    level1Desc: 'Aggregierter Gesamtenergieverbrauch und CO2-Emissionen auf Unternehmensebene. Geeignet für Jahres-Nachhaltigkeitsberichte und ESG-Offenlegungen, aber unzureichend für CBAM-Produktanforderungen.',
    level1Limit: 'Einschränkung: Emissionen können nicht bestimmten Produkten oder Chargen zugeordnet werden — erfüllt CBAM-Anforderungen nicht.',
    level2Label: 'Ebene 2 — Anlage',
    level2Title: 'Werk- / Produktionslinienebene',
    level2Desc: 'Energie und Emissionen nach Produktionslinie oder Prozesseinheit verfolgen. Ermöglicht die Zuteilung von Kohlenstoffkosten zu Produktkategorien und unterstützt KPI-Management auf Prozessebene.',
    level2Limit: 'Teilkonformität: Unterstützt Zuteilung auf Linienebene, kann jedoch Echtzeit-Granularität für Chargen-Rückverfolgung fehlen.',
    level3Label: 'Ebene 3 — Gerät',
    level3Title: 'Geräte- / Chargenebene (CBAM-Kern)',
    level3Desc: 'Echtzeit-Datenerfassung von DCS/SCADA/PLC auf Geräteebene. Ermöglicht präzise Energie- und Emissionszuordnung pro Produktcharge und erfüllt die Anforderung der tatsächlichen Messpriorität von CBAM.',
    level3Limit: 'Vollständige Konformität: Echtzeitmessung + Chargen-Rückverfolgung + Zuteilung auf Produktebene — der Goldstandard für CBAM.',
    cbamRequired: 'CBAM Erforderlich',

    deviceCapTitle: 'BridgeAI Geräteebene-Erfassungsfähigkeit',
    deviceCapDesc: 'BridgeAI verbindet sich direkt mit DCS-, SCADA- und PLC-Systemen über Modbus, OPC-UA, Snap7 und 15+ Industrieprotokolle. Energie- und Emissionsdaten werden pro Gerät, pro Charge erfasst und automatisch Produkten zugeordnet.',

    mrvIntroTitle: 'EU MRV-Verordnung: Drei Kernanforderungen für Kohlenstoffdaten',
    mrvIntroDesc: 'Der EU-Rahmen für Überwachung, Berichterstattung und Verifizierung (MRV) verlangt, dass alle für CBAM eingereichten CO2-Emissionsdaten rückverfolgbar, verifizierbar und manipulationssicher sind.',

    mrvPillarsTitle: 'MRV Drei Säulen',
    mrv1Title: 'Rückverfolgbar — Datenquelle prüfbar',
    mrv1Desc: 'Jeder Datenpunkt muss bis zum Quellinstrument zurückverfolgt werden können. Kalibrierungsaufzeichnungen, Sensor-Metadaten und Messzeitstempel müssen gespeichert und abfragbar sein.',
    mrv1Tag1: 'Gerätekalibrierungsaufzeichnungen',
    mrv1Tag2: 'Sensor-Metadaten',
    mrv1Tag3: 'Messzeitstempel',
    mrv2Title: 'Verifizierbar — Bereit für Drittprüfung',
    mrv2Desc: 'Daten müssen die Vor-Ort-Verifizierung durch akkreditierte Drittparteien unterstützen. BridgeAI bietet strukturierte Audit-Exporte, Datenwiedergabe und rollenbasierten Zugriff für Prüfer.',
    mrv2Tag1: 'Strukturierter Audit-Export',
    mrv2Tag2: 'Datenwiedergabe',
    mrv2Tag3: 'Prüfer-Zugriffskontrolle',
    mrv3Title: 'Manipulationssicher — Blockchain-Beglaubigung',
    mrv3Desc: 'Emissionsaufzeichnungen müssen unveränderlich sein. BridgeAI unterstützt Blockchain-basierte Beglaubigung kritischer Daten-Snapshots — kryptografischer Nachweis, dass Aufzeichnungen nicht verändert wurden.',
    mrv3Tag1: 'Blockchain-Beglaubigung',
    mrv3Tag2: 'Kryptografischer Hash',
    mrv3Tag3: 'Unveränderlicher Audit-Trail',

    mrvFlowTitle: 'MRV Digitale Beweiskette',
    mrvFlow1: 'Geräte-\nMessung',
    mrvFlow2: 'Sichere\nSpeicherung',
    mrvFlow3: 'Blockchain-\nBeglaubigung',
    mrvFlow4: 'Compliance-\nBericht',
    mrvFlow5: 'Drittpartei-\nVerifizierung',

    stat1Val: '100%',
    stat1Label: 'Datenverfolgbarkeit',
    stat2Val: 'ISO 14064',
    stat2Label: 'Verifizierungsbereit',
    stat3Val: 'Blockchain',
    stat3Label: 'Manipulationssicher',
  },
  testimonials: {
    sectionTitle: 'Vertraut von Branchenführern',
    review1Title: 'Bahnbrechende Plattform',
    review1Text: 'BridgeAI hat unsere Fertigungsabläufe transformiert. Echtzeit-Überwachung und KI-Warnungen reduzierten Ausfallzeiten um 40%.',
    review1Name: 'Michael Chen',
    review1Position: 'Operations Director, TechManufacturing Co.',
    review2Title: 'CBAM Compliance vereinfacht',
    review2Text: 'Die automatisierte Compliance-Berichterstattung hat uns unzählige Stunden gespart. EU CBAM-Dokumentation ist jetzt mühelos.',
    review2Name: 'Sarah van der Berg',
    review2Position: 'Sustainability Manager, GreenIndustries NL',
    review3Title: 'Außergewöhnliche Dateneinblicke',
    review3Text: 'Die Analysefähigkeiten sind herausragend. Wir können jetzt Geräteausfälle Wochen im Voraus vorhersagen.',
    review3Name: 'Klaus Müller',
    review3Position: 'CTO, Industrie Solutions GmbH',
    review4Title: 'Nahtlose ERP-Integration',
    review4Text: 'Die Integration mit unserem bestehenden ERP-System verlief reibungslos. Die mehrsprachige Unterstützung ist perfekt für unser globales Team.',
    review4Name: 'Emma Johnson',
    review4Position: 'IT Director, GlobalTech Industries',
    review5Title: 'Hervorragender Support',
    review5Text: 'Die anpassbaren Dashboards und rollenbasierten Berechtigungen passen perfekt zu unserer Organisationsstruktur.',
    review5Name: 'Pierre Dubois',
    review5Position: 'Plant Manager, EuroManufacturing SA',
    review6Title: 'ROI in 3 Monaten',
    review6Text: 'Wir sahen messbaren ROI innerhalb von drei Monaten. Allein die vorausschauende Wartung zahlte sich für die Plattform aus.',
    review6Name: 'Anna Kowalski',
    review6Position: 'CFO, Industrial Dynamics Ltd.'
  },
  cta: {
    title: 'Bereit, Ihre Abläufe zu Transformieren?',
    subtitle: 'Starten Sie Ihre 30-tägige kostenlose Testversion, keine Kreditkarte erforderlich',
    getStarted: 'Jetzt Loslegen'
  },
  footer: {
    tagline: 'Industrielle digitale Transformation ermöglichen',
    platformTitle: 'Plattform',
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    monitoring: 'Überwachung',
    compliance: 'Compliance',
    solutionsTitle: 'Lösungen',
    iotDevices: 'IoT-Geräte',
    dataManagement: 'Datenmanagement',
    aiAlerts: 'KI-Warnungen',
    cbamCompliance: 'CBAM Compliance',
    resourcesTitle: 'Ressourcen',
    documentation: 'Dokumentation',
    apiReference: 'API-Referenz',
    caseStudies: 'Fallstudien',
    blog: 'Blog',
    companyTitle: 'Unternehmen',
    about: 'Über Uns',
    careers: 'Karriere',
    contact: 'Kontakt',
    privacy: 'Datenschutz',
    stayConnected: 'Bleiben Sie Verbunden',
    newsletterText: 'Erhalten Sie Plattform-Updates und Brancheneinblicke',
    emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
    subscribe: 'Abonnieren',
    subscribing: 'Abonnieren...',
    subscribeSuccess: 'Vielen Dank für Ihr Abonnement!',
    errorInvalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    errorSubmission: 'Abonnement fehlgeschlagen. Bitte versuchen Sie es erneut.',
    copyright: '© 2026 BridgeAI. Alle Rechte vorbehalten.'
  },
  dataLifecycle: {
    modalTitle: 'Datenlebenszyklus-Management',
    modalSubtitle: 'Durchgängiger industrieller Datenfluss — vom Gerät zum Dashboard',
    flowLabel: 'Vollständiger Datenfluss',
    flowTitle: 'Vom Industriegerät zum Einblick',
    flowDesc: 'BridgeAI verwaltet den gesamten Datenweg: Erfassung von Rohdaten aus Feldgeräten, Verarbeitung am Edge, sichere Übertragung in die Cloud und Bereitstellung umsetzbarer Erkenntnisse über Dashboards und APIs.',
    step1Title: 'Industriegeräte',
    step1Desc: 'Verbinden Sie SPSen, Antriebe, Zähler und Regler über Modbus, RS485, OPC-UA, Snap7, PROFINET und mehr.',
    step2Title: 'Sensor-Telemetrie-Erfassung',
    step2Desc: 'Erfassen Sie Temperatur-, Druck-, Vibrations-, Durchfluss-, Leistungs- und benutzerdefinierte Sensordaten mit hoher Frequenz.',
    step3Title: 'Intelligente Edge-Verarbeitung',
    step3Desc: 'Lokales Edge-Gerät filtert, aggregiert und komprimiert Daten vor der Übertragung — reduziert Bandbreite um bis zu 80%.',
    step4Title: 'Sichere Übertragung',
    step4Desc: 'Senden Sie Daten über MQTT, benutzerdefiniertes TCP/UDP, HTTP/REST oder WebSocket mit Ende-zu-Ende-TLS-Verschlüsselung.',
    step5Title: 'ETL-Pipeline',
    step5Desc: 'Extrahieren, transformieren und laden Sie Daten mit Validierung und Anreicherung für Qualität und Konsistenz.',
    step6Title: 'Datenbus',
    step6Desc: 'Verteilen Sie Datenströme über Kafka oder RabbitMQ Event-Bus, um Produzenten und Konsumenten zu entkoppeln.',
    step7Title: 'Speicherschicht',
    step7Desc: 'Persistieren Sie Daten in PostgreSQL für relationale Datensätze, TimescaleDB/InfluxDB für Zeitreihen und S3 für Archive.',
    step8Title: 'Datenpipelines',
    step8Desc: 'Leiten Sie Daten durch normale Verarbeitung, KI-Inferenz, Alarmbewertung und Berichtsgenerierungs-Pipelines.',
    step9Title: 'Web- & App-Präsentation',
    step9Desc: 'Liefern Sie Erkenntnisse über Echtzeit-Web-Dashboards, mobile Apps, REST-APIs, Webhooks und ERP-Integrationen.',
    pipelinesTitle: 'Verarbeitungs-Pipeline-Typen',
    pipeline1Title: 'Normale Verarbeitungs-Pipeline',
    pipeline1Desc: 'Standard-Datenfluss für Aggregation, KPI-Berechnung, Schwellenwert-Alarme und geplante Berichtsgenerierung. Verarbeitet den Großteil der Betriebsdaten mit niedriger Latenz und hoher Zuverlässigkeit.',
    pipeline2Title: 'KI-Verarbeitungs-Pipeline',
    pipeline2Desc: 'Machine-Learning-Inferenz-Pipeline für Anomalieerkennung, vorausschauende Wartung und Mustererkennung. Modelle werden auf historischen Daten trainiert und kontinuierlich aktualisiert.',
    stat1: 'Ende-zu-Ende-Latenz',
    stat2: 'Datenpunkte / Sek.',
    stat3: 'Plattform-Betriebszeit',
    stat4: 'Industrieprotokolle',
  },
  aiAlerts: {
    modalTitle: 'KI-Gestützte Warnungen',
    modalSubtitle: 'Dualer Warnmodus: Benutzerdefinierte Regeln + KI-Anomalieerkennung',
    badge: 'Intelligente Warn-Engine',
    flowTitle: 'Jedem Problem einen Schritt voraus',
    flowDesc: 'BridgeAI kombiniert regelbasierte Warnungen mit KI-gesteuerter Anomalieerkennung — Sie werden sofort benachrichtigt, wenn etwas schiefläuft, oder sogar bevor es passiert.',
    flowLabel: 'Warnverarbeitungsfluss',
    flow1: 'Sensordaten',
    flow2: 'Regel-Engine',
    flow3: 'KI-Analyse',
    flow4: 'Warnung Ausgelöst',
    flow5: 'Benachrichtigung',
    flow6: 'Aktion / Behebung',
    dualModeLabel: 'Dualer Warnmodus',
    rule1Title: 'Benutzerdefinierte Regelwarnungen',
    rule1Desc: 'Erstellen Sie benutzerdefinierte Warnregeln basierend auf Schwellenwerten, Bedingungen, Zeitfenstern und Multi-Metrik-Logik. Volle Kontrolle darüber, wann und wie Sie benachrichtigt werden.',
    rule2Title: 'KI Automatische Anomalieerkennung',
    rule2Desc: 'Die KI lernt kontinuierlich das normale Verhalten Ihrer Geräte und löst automatisch Warnungen aus, wenn Anomalien, abnormale Muster oder frühe Anzeichen von Ausfällen erkannt werden.',
    featuresLabel: 'Warnfunktionen',
    feat1Title: 'Multi-Kanal-Benachrichtigungen',
    feat1Desc: 'Warnungen per E-Mail, SMS, Webhook, PagerDuty oder Slack — erreichen Sie sofort die richtige Person.',
    feat2Title: 'Prädiktive Einblicke',
    feat2Desc: 'KI-Trendanalyse und Prognosen helfen Ihnen, Ursachen zu verstehen und zukünftige Probleme vorherzusagen.',
    feat3Title: 'Warnverlauf & Audit',
    feat3Desc: 'Vollständiges Warnprotokoll mit Audit-Trail, Wiedergabe und Export — vollständige Transparenz über jedes Ereignis.',
    feat4Title: 'Intelligentes Warnmanagement',
    feat4Desc: 'Prioritätsstufen, Eskalationsrichtlinien, Unterdrückung und Gruppierung zur Lärmreduzierung.',
    stat1: 'Warnlatenz',
    stat2: 'Erkennungsgenauigkeit',
    stat3: 'Regeltypen',
    stat4: 'Benachrichtigungskanäle',
  },
  cbamModal: {
    // ... existing code ...
  },
  contactForm: {
    title: 'Demo anfordern',
    fields: {
      name: 'Vollständiger Name',
      company: 'Firmenname',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      message: 'Nachricht'
    },
    placeholders: {
      name: 'Geben Sie Ihren vollständigen Namen ein',
      company: 'Geben Sie Ihren Firmennamen ein',
      email: 'Geben Sie Ihre E-Mail-Adresse ein',
      phone: 'Geben Sie Ihre Telefonnummer ein',
      message: 'Erzählen Sie uns von Ihren Anforderungen...'
    },
    errors: {
      nameRequired: 'Name ist erforderlich',
      companyRequired: 'Firmenname ist erforderlich',
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      phoneRequired: 'Telefonnummer ist erforderlich',
      messageRequired: 'Nachricht ist erforderlich',
      messageTooLong: 'Nachricht darf 500 Zeichen nicht überschreiten'
    },
    submit: 'Anfrage senden',
    submitting: 'Wird gesendet...',
    successTitle: 'Vielen Dank!',
    successMessage: 'Wir haben Ihre Anfrage erhalten und werden uns in Kürze bei Ihnen melden.'
  },
  about: {
    title: 'Über Uns',
    introTitle: 'Wer Wir Sind',
    introText: 'BridgeAI ist ein führender Anbieter von industriellen IoT- und digitalen Transformationslösungen. Wir helfen Herstellern, Abläufe zu optimieren, den CO2-Fußabdruck zu reduzieren und EU-Compliance durch modernste Technologie und KI-gesteuerte Erkenntnisse zu erreichen.',
    missionTitle: 'Unsere Mission',
    missionText: 'Industrieunternehmen mit intelligenten, datengesteuerten Lösungen zu stärken, die operative Exzellenz und nachhaltiges Wachstum fördern.',
    visionTitle: 'Unsere Vision',
    visionText: 'Zum globalen Standard für industrielle digitale Transformation zu werden und eine intelligentere, grünere und effizientere Fertigungszukunft zu ermöglichen.',
    valuesTitle: 'Kernwerte',
    value1Title: 'Innovation',
    value1Text: 'Kontinuierliches Erweitern der Grenzen von industriellem IoT und KI-Technologie.',
    value2Title: 'Zuverlässigkeit',
    value2Text: 'Bereitstellung robuster, sicherer und unternehmenskritischer Lösungen, denen unsere Kunden vertrauen können.',
    value3Title: 'Nachhaltigkeit',
    value3Text: 'Verpflichtet, Industrien bei der Reduzierung von Umweltauswirkungen und der Erreichung von Klimaneutralität zu unterstützen.',
    value4Title: 'Partnerschaft',
    value4Text: 'Aufbau langfristiger Beziehungen basierend auf gegenseitigem Erfolg und gemeinsamen Werten.',
    teamTitle: 'Unser Team',
    teamText: 'Unser Team besteht aus Branchenveteranen, Datenwissenschaftlern und IoT-Spezialisten mit jahrzehntelanger kombinierter Erfahrung in Fertigung, Automatisierung und Unternehmenssoftware. Wir bringen tiefes Fachwissen und Leidenschaft für die Lösung komplexer industrieller Herausforderungen mit.',
    teamExperts: 'Branchenexperten',
    teamYears: 'Jahre Erfahrung',
    teamProjects: 'Abgeschlossene Projekte'
  },
  contact: {
    title: 'Kontakt',
    infoTitle: 'Kontaktieren Sie Uns',
    infoText: 'Haben Sie Fragen oder möchten Sie mehr über BridgeAI erfahren? Unser Team ist hier, um zu helfen. Kontaktieren Sie uns über einen der folgenden Kanäle.',
    addressTitle: 'Büroadresse',
    addressText: 'Hengelosestraat 581, 7581 AG Enschede, Niederlande',
    emailTitle: 'E-Mail',
    phoneTitle: 'Telefon',
    hoursTitle: 'Geschäftszeiten',
    hoursText: 'Montag - Freitag: 9:00 - 18:00 Uhr MEZ',
    formTitle: 'Senden Sie Uns Eine Nachricht',
    name: 'Vollständiger Name',
    company: 'Firmenname',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    message: 'Nachricht',
    namePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
    companyPlaceholder: 'Geben Sie Ihren Firmennamen ein',
    emailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    phonePlaceholder: 'Geben Sie Ihre Telefonnummer ein',
    messagePlaceholder: 'Sagen Sie uns, wie wir helfen können...',
    errorName: 'Name ist erforderlich',
    errorCompany: 'Firmenname ist erforderlich',
    errorEmail: 'E-Mail ist erforderlich',
    errorEmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    errorPhone: 'Telefonnummer ist erforderlich',
    errorMessage: 'Nachricht ist erforderlich',
    errorMessageLength: 'Nachricht darf 500 Zeichen nicht überschreiten',
    submit: 'Nachricht Senden',
    submitting: 'Wird gesendet...',
    successMessage: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.'
  },
  privacy: {
    title: 'Datenschutzerklärung',
    lastUpdated: 'Zuletzt aktualisiert:',
    lastUpdatedDate: '15. Januar 2026',
    introTitle: 'Einleitung',
    introText: 'BridgeAI ("wir", "unser" oder "uns") verpflichtet sich zum Schutz Ihrer Privatsphäre. Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen sammeln, verwenden, offenlegen und schützen, wenn Sie unsere industrielle IoT-Plattform und -Dienste nutzen.',
    collectionTitle: 'Informationen, Die Wir Sammeln',
    collectionText: 'Wir sammeln Informationen, die Sie uns direkt zur Verfügung stellen, einschließlich:',
    collectionItem1: 'Persönliche Identifikationsinformationen (Name, E-Mail-Adresse, Telefonnummer, Firmenname)',
    collectionItem2: 'Kontoanmeldeinformationen und Authentifizierungsdaten',
    collectionItem3: 'Industriegerätedaten, Sensormesswerte und Telemetrieinformationen',
    collectionItem4: 'Nutzungsdaten, Protokolldateien und Analyseinformationen',
    usageTitle: 'Wie Wir Ihre Informationen Verwenden',
    usageText: 'Wir verwenden die gesammelten Informationen, um:',
    usageItem1: 'Unsere Plattform und Dienste bereitzustellen, zu warten und zu verbessern',
    usageItem2: 'Transaktionen zu verarbeiten und zugehörige Informationen zu senden',
    usageItem3: 'Technische Hinweise, Updates, Sicherheitswarnungen und Support-Nachrichten zu senden',
    usageItem4: 'Auf Ihre Kommentare, Fragen und Kundendienstanfragen zu antworten',
    storageTitle: 'Datenspeicherung und Sicherheit',
    storageText: 'Wir implementieren branchenübliche Sicherheitsmaßnahmen zum Schutz Ihrer Daten, einschließlich Verschlüsselung, Zugriffskontrollen und regelmäßiger Sicherheitsaudits. Ihre Industriedaten werden in sicheren, EU-konformen Rechenzentren mit Redundanz- und Backup-Systemen gespeichert.',
    sharingTitle: 'Informationsweitergabe',
    sharingText: 'Wir verkaufen, handeln oder vermieten Ihre persönlichen Informationen nicht an Dritte. Wir können Ihre Informationen nur unter folgenden Umständen weitergeben:',
    sharingNote: 'Wichtig:',
    sharingNoteText: 'Wir werden Ihre Industriegerätedaten oder proprietären Informationen niemals ohne Ihre ausdrückliche Zustimmung weitergeben.',
    rightsTitle: 'Ihre Rechte',
    rightsText: 'Gemäß DSGVO und geltenden Datenschutzgesetzen haben Sie folgende Rechte:',
    rightAccessTitle: 'Recht auf Zugang',
    rightAccessText: 'Kopien Ihrer persönlichen Daten anfordern',
    rightCorrectTitle: 'Recht auf Berichtigung',
    rightCorrectText: 'Korrektur ungenauer Daten anfordern',
    rightDeleteTitle: 'Recht auf Löschung',
    rightDeleteText: 'Löschung Ihrer persönlichen Daten anfordern',
    rightPortabilityTitle: 'Recht auf Datenübertragbarkeit',
    rightPortabilityText: 'Übertragung Ihrer Daten an einen anderen Dienst anfordern',
    cookiesTitle: 'Cookies und Tracking',
    cookiesText: 'Wir verwenden Cookies und ähnliche Tracking-Technologien, um Aktivitäten auf unserer Plattform zu verfolgen und bestimmte Informationen zu speichern. Sie können Ihren Browser anweisen, alle Cookies abzulehnen oder anzuzeigen, wenn ein Cookie gesendet wird.',
    contactTitle: 'Kontaktieren Sie Uns',
    contactText: 'Wenn Sie Fragen zu dieser Datenschutzerklärung haben oder Ihre Datenschutzrechte ausüben möchten, kontaktieren Sie uns bitte unter:'
  }
};
